<template>
  <div class="lp">

    <!-- ===== HERO IMAGE (1·2.png — 유지) ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/1.png" alt="천안 휴먼빌 퍼스트시티" />
      <img src="@/assets/2.png" alt="천안 휴먼빌 퍼스트시티" />
    </section>

    <!-- ===== INTRO — 성성호수공원 생활권 ===== -->
    <section class="lp-section lp-intro">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow" v-reveal>Cheonan · Seongseong Lake Park</span>
        <p class="intro-figure" v-reveal="{ delay: 80 }">
          <span class="intro-num" v-countup="1541">1541</span>
          <span class="intro-num-unit">세대</span>
        </p>
        <h2 class="lp-section-title" v-reveal="{ delay: 160 }">
          천안의 새로운 중심,<br/>
          <em>성성호수공원 생활권</em> 위에
        </h2>
        <div class="lp-gold-line center" v-reveal="{ delay: 220 }"></div>
        <p class="intro-lead" v-reveal="{ delay: 260 }">
          성성·업성·부성지구와 함께 2만 5천여 세대 규모의 새 주거타운으로 거듭나는 천안 성성호수공원 생활권.<br class="pc-br"/>
          호수를 품은 그 중심에 <strong>천안 휴먼빌 퍼스트시티</strong> 총 1,541세대가 들어섭니다.
        </p>
      </div>
    </section>

    <!-- ===== OVERVIEW — 사업 개요 ===== -->
    <section class="lp-section lp-overview">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Overview</span>
        <h2 class="lp-section-title">
          천안 성성호수공원 생활권<br/>
          <em>프리미엄 주거단지</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <figure class="edge-media kb" v-reveal>
        <img src="@/assets/3.png" alt="천안 휴먼빌 퍼스트시티 야경 조감" />
      </figure>

      <div class="lp-inner">
        <dl class="ov-list" v-reveal>
          <div class="ov-row" v-for="(it, i) in overviewItems" :key="i">
            <dt class="ov-label">{{ it.label }}</dt>
            <dd class="ov-value" v-html="it.value"></dd>
          </div>
        </dl>
      </div>
    </section>

    <!-- ===== LOCATION — 입지환경 ===== -->
    <section class="lp-section lp-location">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Location</span>
        <h2 class="lp-section-title">
          천안이 기다린 새도시<br/>
          <em>입지환경</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/입지환경.jpg" alt="천안 휴먼빌 퍼스트시티 입지환경" class="section-img" />
      </div>

      <div class="lp-inner center" v-reveal>
        <h2 class="lp-section-title loc-headline">
          총 <em>1,541세대</em><br/>
          성성생활권 최대 규모 단지!
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <div class="loc-points converge" v-converge>
          <article class="loc-point" v-for="(p, i) in locationPoints" :key="i">
            <span class="loc-point-num">0{{ i + 1 }}</span>
            <h3 class="loc-point-title">{{ p.title }}</h3>
            <p class="loc-point-desc">{{ p.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== PREMIUM — 여섯 가지 프리미엄 ===== -->
    <section class="lp-section lp-district">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">HUMANVILL PREMIUM 6</span>
        <h2 class="lp-section-title">
          천안 휴먼빌 퍼스트시티만의<br/>
          <em>여섯 가지 프리미엄</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <div class="dist-grid">
          <article class="dist-card" v-for="(d, i) in districtItems" :key="i" v-reveal="{ delay: i * 70 }">
            <span class="dist-en">{{ d.en }}</span>
            <h3 class="dist-ko">{{ d.ko }}</h3>
            <p class="dist-desc">{{ d.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== SCALE — 규모 · 단지 배치 ===== -->
    <section class="lp-section lp-scale">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Site Plan</span>
        <h2 class="lp-section-title">
          지하 3층 ~ 지상 33층, 12개 동<br/>
          <em>총 1,541세대</em>
        </h2>
        <div class="lp-gold-line center"></div>
        <p class="scale-lead">
          채광과 통풍을 고려한 전 세대 남향 위주 배치와 4BAY 판상형 구조(일부 세대 제외),
          약 40%의 친환경 조경 비율을 자랑하는 프리미엄 단지설계.
        </p>
      </div>

      <div class="lp-inner">
        <img src="@/assets/단지배치도.jpg" alt="천안 휴먼빌 퍼스트시티 단지배치도" class="section-img" />
        <img src="@/assets/동호수배치도.jpg" alt="천안 휴먼빌 퍼스트시티 동호수배치도" class="section-img" />
      </div>
    </section>

    <!-- ===== 단지설계 ===== -->
    <section class="lp-section lp-design">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Design</span>
        <h2 class="lp-section-title">
          세심하게 완성한<br/>
          <em>단지설계</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/단지설계.jpg" alt="천안 휴먼빌 퍼스트시티 단지설계" class="section-img" />
      </div>
    </section>

    <!-- ===== UNIT — 84㎡ 4타입 ===== -->
    <section class="lp-section lp-unit">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Unit Plan</span>
        <h2 class="lp-section-title">
          라이프스타일에 맞춘<br/>
          <em>네 가지 84㎡ 타입</em>
        </h2>
        <div class="lp-gold-line center"></div>

        <div class="unit-tabs">
          <button
            v-for="(u, i) in unitTypes"
            :key="u.key"
            class="unit-tab"
            :class="{ active: activeUnit === i }"
            @click="setUnit(i)">
            {{ u.label }} TYPE
          </button>
        </div>

        <div class="unit-img-wrap">
          <img
            :src="getUnitImg(unitTypes[activeUnit].label)"
            :alt="unitTypes[activeUnit].label + ' TYPE 평면'"
            class="unit-img"
          />
        </div>

        <dl class="unit-spec">
          <div class="us-row"><dt>전용면적</dt><dd>{{ unitTypes[activeUnit].exclusive }}㎡</dd></div>
          <div class="us-row"><dt>세대수</dt><dd><strong>{{ unitTypes[activeUnit].households }}</strong></dd></div>
          <div class="us-row"><dt>특화 설계</dt><dd>{{ unitTypes[activeUnit].feature }}</dd></div>
          <div class="us-row"><dt>구조</dt><dd>{{ unitTypes[activeUnit].structure }}</dd></div>
        </dl>
      </div>
    </section>

    <!-- ===== COMMUNITY — 휴먼빌 라운지 ===== -->
    <section class="lp-section lp-amenity">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Humanvill Lounge</span>
        <h2 class="lp-section-title">
          약 1,600평 규모<br/>
          <em>입주민 전용 커뮤니티</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/community1.jpg" alt="천안 휴먼빌 퍼스트시티 커뮤니티 지하 2층 평면" class="section-img" />
      </div>

      <div class="lp-inner">
        <div class="comm-grid">
          <article class="dist-card">
            <h3 class="dist-ko">휴먼빌 라운지</h3>
            <p class="dist-desc">입주민 전용 휴먼빌 라운지에서만 경험할 수 있는 고품격 커뮤니티 시설로 실내와 실외를 함께 즐기는 공간</p>
          </article>
          <article class="dist-card">
            <h3 class="dist-ko">북클럽</h3>
            <p class="dist-desc">편안한 분위기 속에서 교육 · 문화 등을 누릴 수 있는 가족 모두를 위한 공간</p>
          </article>
        </div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/community2.jpg" alt="천안 휴먼빌 퍼스트시티 커뮤니티 지하 3층 평면" class="section-img" />
      </div>

      <div class="lp-inner">
        <div class="comm-grid">
          <article class="dist-card">
            <h3 class="dist-ko">골프클럽</h3>
            <p class="dist-desc">날씨에 상관없이 누구나 편하게 골프를 즐길 수 있는 실내 연습공간</p>
          </article>
          <article class="dist-card">
            <h3 class="dist-ko">피트니스</h3>
            <p class="dist-desc">다양한 운동기구를 통해 입주민들의 건강을 향상시키는 공간</p>
          </article>
        </div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/community3.jpg" alt="천안 휴먼빌 퍼스트시티 휴먼빌 게스트하우스" class="section-img" />
      </div>
    </section>

    <!-- ===== PROGRAM — 특화 프로그램 ===== -->
    <section class="lp-section lp-program">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Program</span>
        <h2 class="lp-section-title">
          온 가족이 누리는<br/>
          <em>특화 프로그램</em>
        </h2>
        <div class="lp-gold-line center"></div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/프로그램1.jpg" alt="천안 휴먼빌 퍼스트시티 런&amp;플레이 프로그램" class="section-img" />
        <div class="program-cap">
          <h3 class="program-title">런&amp;플레이</h3>
          <p class="program-desc">유아 발달 단계에 최적화된<br/>신체놀이 및 교육적 설계!</p>
        </div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/프로그램2.jpg" alt="천안 휴먼빌 퍼스트시티 주니토니 발레스타 프로그램" class="section-img" />
        <div class="program-cap">
          <h3 class="program-title">주니토니 발레스타</h3>
          <p class="program-desc">우리 아이의 유연성과<br/>표현력을 길러주는 발레교육!</p>
        </div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/프로그램3.jpg" alt="천안 휴먼빌 퍼스트시티 전태풍 앵클브레이커 농구 프로그램" class="section-img" />
        <div class="program-cap">
          <h3 class="program-title">전태풍 앵클브레이커</h3>
          <p class="program-desc">전 KBL 프로농구선수 전태풍의<br/>특급 농구 스킬과 노하우 전수!</p>
        </div>
      </div>

      <div class="lp-inner">
        <img src="@/assets/프로그램4.jpg" alt="천안 휴먼빌 퍼스트시티 성인 GX 강습 프로그램" class="section-img" />
        <div class="program-cap">
          <h3 class="program-title">성인들을 위한 GX 강습</h3>
          <p class="program-desc">입주 후 바로 누릴 수 있는<br/>커뮤니티 특화 프로그램!</p>
        </div>
      </div>
    </section>

    <!-- ===== BRAND — 일신건영 휴먼빌 ===== -->
    <section class="lp-section lp-rosewood">
      <div class="lp-inner narrow center" v-reveal>
        <span class="lp-eyebrow">Humanvill Brand</span>
        <h2 class="lp-section-title">
          입주민이 인정한 브랜드<br/>
          <em>일신건영 휴먼빌</em>
        </h2>
        <div class="lp-gold-line center"></div>
        <p class="split-lead">
          전국 곳곳에서 입주민의 신뢰로 증명된 휴먼빌.
          <strong>기본부터 다른 설계</strong>로, 무옵션으로도 높은 완성도를 선사합니다.
        </p>
        <ul class="rose-perks">
          <li>무옵션으로도 <strong>완성도 높은 기본 사양</strong></li>
          <li>전 세대 <strong>남향 위주 4BAY 판상형</strong> 설계 (일부 세대 제외)</li>
          <li>약 <strong>40% 친환경 조경</strong>의 명품단지</li>
        </ul>
        <p class="rose-note">※ 평택 화양 · 이천 에듀파크 · 양평 리버파크 · 속초 조양 등 다수 단지에서 입주민 감사패로 검증된 휴먼빌 브랜드입니다.</p>
      </div>

      <div class="lp-inner">
        <img src="@/assets/brand.jpg" alt="일신건영 휴먼빌 브랜드" class="section-img" />
      </div>
    </section>

    <!-- ===== TRUST — 시행 · 시공 · 설계 ===== -->
    <section class="lp-section lp-trust">
      <div class="lp-inner center" v-reveal>
        <span class="lp-eyebrow">Design &amp; Brand</span>
        <h2 class="lp-section-title">
          신뢰가 완성하는<br/>
          <em>천안의 새로운 랜드마크</em>
        </h2>
        <div class="lp-gold-line center"></div>

        <div class="trust-grid converge" v-converge>
          <article class="trust-card" v-for="(c, i) in constructionItems" :key="i">
            <span class="trust-role">{{ c.role }}</span>
            <h3 class="trust-name">{{ c.name }}</h3>
            <p class="trust-desc">{{ c.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== CTA — 방문 예약 ===== -->
    <section class="lp-section lp-cta">
      <div class="lp-inner narrow center" v-reveal>
        <span class="lp-eyebrow">Visit Reservation</span>
        <h2 class="lp-section-title">
          지금, 모델하우스로<br/>
          <em>초대합니다</em>
        </h2>
        <div class="lp-gold-line center"></div>

        <p class="cta-desc">
          <strong>천안 휴먼빌 퍼스트시티</strong>는 방문 예약제로 운영됩니다.<br class="pc-br"/>
          방문 예약 후, 전담 상담을 통해 자세히 안내받으실 수 있습니다.
        </p>

        <button class="cta-btn" @click="openRegister">
          <span class="cta-btn-en">VISIT RESERVATION</span>
          <span class="cta-btn-kr">방문 예약하기</span>
          <span class="cta-btn-arrow">→</span>
        </button>

        <p class="cta-note">
          ※ 본 사이트는 천안 휴먼빌 퍼스트시티 모델하우스 방문 예약 안내 페이지이며,<br class="pc-br"/>
          시행사·시공사의 공식 홈페이지가 아닙니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  directives: {
    // 스크롤 진입 시 페이드/슬라이드 등장
    reveal: {
      mounted(el, binding) {
        el.classList.add('reveal')
        const delay = binding.value && binding.value.delay ? binding.value.delay : 0
        if (delay) el.style.transitionDelay = delay + 'ms'
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              el.classList.add('is-revealed')
              obs.unobserve(el)
            }
          })
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
        io.observe(el)
      }
    },
    // 뷰포트 진입 시 0 → 목표값 카운트업
    countup: {
      mounted(el, binding) {
        const target = Number(binding.value) || 0
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(e => {
            if (!e.isIntersecting) return
            const dur = 1500
            const start = performance.now()
            const tick = (now) => {
              const p = Math.min((now - start) / dur, 1)
              const eased = 1 - Math.pow(1 - p, 3)
              el.textContent = Math.round(eased * target)
              if (p < 1) requestAnimationFrame(tick)
              else el.textContent = target
            }
            requestAnimationFrame(tick)
            obs.unobserve(el)
          })
        }, { threshold: 0.6 })
        io.observe(el)
      }
    },
    // 2x2 카드가 네 모서리에서 중앙으로 모여드는 효과
    converge: {
      mounted(el) {
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(e => {
            if (e.isIntersecting) { el.classList.add('is-revealed'); obs.unobserve(el) }
          })
        }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' })
        io.observe(el)
      }
    }
  },
  data() {
    return {
      overviewItems: [
        { label: '대지위치',    value: '충남 천안시 서북구 부대동 416-1 일원' },
        { label: '대지면적',    value: '75,838.0000㎡' },
        { label: '건축면적',    value: '9,994.2126㎡' },
        { label: '연면적',      value: '267,025.5918㎡' },
        { label: '건폐/용적률', value: '13.18% / 237.40%' },
        { label: '건축규모',    value: '지하 3층, 지상 33층 / 아파트 총 <strong>1,541세대</strong>' },
      ],

      locationPoints: [
        { title: '갈수록 빨라질 교통의 중심', desc: '삼성대로, 번영로, 천안대로, 천안IC, 1호선 부성역(29년 예정), 천안역 GTX-C(연장계획 검토 중)' },
        { title: '일상이 완벽한 생활의 중심', desc: '이마트, 코스트코, 호수공원 상권 등 도심 인프라와 성성호수공원의 힐링자연' },
        { title: '가까이 다 갖춘 교육의 중심', desc: '단지 인근 초등학교(예정), 가람중, 부성중, 오성고 등 우수한 학교와 성성지구 학원가가 인접한 안심 교육환경' },
        { title: '내일이 눈부신 비전의 중심', desc: '부대/부성/업성/성성지구 등 성성호수공원 중심으로 연결되는 새로운 도시개발 비전' },
      ],

      districtItems: [
        { en: 'PREMIUM 01', ko: '천안을 주도할 새도시 프리미엄',     desc: '불당지구 앞 천안을 리드하는 약 2만 5천여 세대 신주거중심의 탄생' },
        { en: 'PREMIUM 02', ko: '천안 첫 번째 휴먼빌 프리미엄',       desc: '총 1,541세대 규모, 천안 첫 휴먼빌 프리미엄 대단지' },
        { en: 'PREMIUM 03', ko: '선택의 폭이 다양한 특화평면 디자인', desc: '전 세대 84㎡ 단일 타입으로, 라이프스타일에 따라 누리는 맞춤형 특화 평면' },
        { en: 'PREMIUM 04', ko: '다채롭게 누리는 도심 인프라',        desc: '성성호수공원 생활권과 불당지구 생활권 복합 인프라' },
        { en: 'PREMIUM 05', ko: '단지와 인접한 안심 교육환경',        desc: '근거리에 위치한 유·초·중·고교와 성성지구 교육 인프라' },
        { en: 'PREMIUM 06', ko: '가치를 더해가는 쾌속 교통망',        desc: '1호선 부성역(29년 예정), 삼성대로·번영로, 천안역 GTX-C 노선(연장계획 검토 중)' },
      ],

      unitTypes: [
        { key: '84A', label: '84A', exclusive: '84', households: '310세대', feature: '주방 특화',  structure: '4BAY 판상형' },
        { key: '84B', label: '84B', exclusive: '84', households: '275세대', feature: '거실 특화',  structure: '4BAY 판상형' },
        { key: '84C', label: '84C', exclusive: '84', households: '335세대', feature: '수납 특화',  structure: '4BAY 판상형' },
        { key: '84D', label: '84D', exclusive: '84', households: '621세대', feature: '3면 발코니', structure: '침실 4개' },
      ],
      activeUnit: 0,

      constructionItems: [
        { role: '시행·시공',  name: '일신건영',              desc: '입주민의 신뢰로 증명된 휴먼빌 브랜드의 시행·시공' },
        { role: '브랜드',     name: '휴먼빌',                desc: '전국 다수 단지의 입주 실적과 감사패로 검증된 주거 브랜드' },
        { role: '단지설계',   name: '남향 4BAY 판상형',      desc: '채광·통풍을 고려한 전 세대 남향 위주 배치 (일부 세대 제외)' },
        { role: '조경',       name: '약 40% 친환경 조경',    desc: '호수공원 곁, 숲을 품은 명품 조경단지' },
      ],
    }
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    },
    getUnitImg(label) {
      return require('@/assets/unit/' + label + '.jpg')
    },
    setUnit(idx) {
      this.activeUnit = idx
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT / LUXURY GOLD THEME ==================== */
.lp {
  --pk-ink: #16161C;
  --pk-noir: #0B0B0F;
  --pk-gold: #032330;
  --pk-gold-dark: #032330;
  --pk-gold-soft: rgba(3, 35, 48, 0.20);
  --pk-grey: rgba(11, 11, 15, 0.60);
  --pk-cream: #FAF8F3;
  --pk-bone: #F1EBDD;
  background: #ffffff;
  color: var(--pk-ink);
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
}

.lp em {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  color: var(--pk-gold-dark);
}
.lp strong { font-weight: 600; color: var(--pk-noir); }

/* 강제 줄바꿈은 PC에서만 — 모바일은 자연 흐름 */
.pc-br { display: none; }

/* ===== 스크롤 등장 애니메이션 ===== */
.reveal {
  opacity: 0;
  transform: translateY(42px);
  transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1),
              transform 1s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: opacity, transform;
}
.reveal.is-revealed { opacity: 1; transform: none; }

/* 큰 이미지: 등장하며 살짝 줌아웃 */
.edge-media, .split-media, .loc-map, .gal { overflow: hidden; }
.edge-media img, .split-media img, .loc-map img {
  transition: transform 1.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.reveal.edge-media img,
.reveal.split-media img,
.reveal.loc-map img { transform: scale(1.14); }
.reveal.is-revealed.edge-media img,
.reveal.is-revealed.split-media img,
.reveal.is-revealed.loc-map img { transform: scale(1); }

/* ===== 2x2 카드 컨버지(네 모서리 → 중앙으로 모여듦) ===== */
.converge > * {
  opacity: 0;
  transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1),
              transform 1s cubic-bezier(0.16, 1, 0.3, 1),
              background 0.4s ease, border-color 0.4s ease;
  will-change: opacity, transform;
}
/* 초기 위치는 '아직 안 보일 때'만 — 보이면 제자리(none)로 복귀 */
.converge:not(.is-revealed) > *:nth-child(1) { transform: translate(-38px, -26px) scale(0.94); }
.converge:not(.is-revealed) > *:nth-child(2) { transform: translate( 38px, -26px) scale(0.94); }
.converge:not(.is-revealed) > *:nth-child(3) { transform: translate(-38px,  26px) scale(0.94); }
.converge:not(.is-revealed) > *:nth-child(4) { transform: translate( 38px,  26px) scale(0.94); }
.converge.is-revealed > * { opacity: 1; transform: none; }

/* ===== Ken Burns: 조감 이미지 상시 은은한 줌 ===== */
@keyframes kbZoom { from { transform: scale(1.02); } to { transform: scale(1.12); } }
.edge-media.kb img { animation: kbZoom 22s ease-in-out infinite alternate; }

@media (prefers-reduced-motion: reduce) {
  .reveal, .converge > * { opacity: 1 !important; transform: none !important; transition: none !important; }
  .converge:not(.is-revealed) > * { transform: none !important; }
  .reveal img, .edge-media.kb img { transform: none !important; animation: none !important; }
}

.lp-inner {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 26px;
}
.lp-inner.narrow { max-width: 760px; }
.lp-inner.center { text-align: center; }

.lp-section { padding: 90px 0; position: relative; }

.lp-eyebrow {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--pk-gold-dark);
  margin-bottom: 20px;
}

.lp-section-title {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 30px;
  line-height: 1.45;
  color: var(--pk-noir);
  letter-spacing: -0.02em;
  margin-bottom: 26px;
  word-break: keep-all;
}
.lp-section-title em {
  font-family: var(--font-serif-en);
  font-weight: 400;
  font-style: italic;
  color: var(--pk-gold-dark);
}

.lp-gold-line {
  width: 56px; height: 1px;
  background: linear-gradient(90deg, var(--pk-gold), rgba(3,35,48,0));
  margin: 0 0 36px;
}
.lp-gold-line.center { margin-left: auto; margin-right: auto; }

/* ==================== HERO ==================== */
.lp-hero-img { width: 100%; background: #fff; line-height: 0; }
.lp-hero-img img { display: block; width: 100%; height: auto; }

/* 섹션 내 단일 디자인 이미지 (입지환경 등) */
.section-img { display: block; width: 100%; height: auto; margin: 8px auto 0; }
.loc-headline { margin-top: 56px; }

/* 프로그램 캡션 */
.program-cap { text-align: center; margin: 20px 0 48px; }
.program-title {
  font-family: var(--font-serif-kr); font-size: 20px; font-weight: 600;
  color: var(--pk-noir); letter-spacing: -0.02em; margin-bottom: 10px; word-break: keep-all;
}
.program-desc {
  font-family: var(--font-sans); font-size: 14px; line-height: 1.7;
  color: var(--pk-grey); word-break: keep-all;
}

/* 커뮤니티 시설 텍스트 카드 */
.comm-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-top: 28px; }
.comm-extra {
  margin-top: 16px; text-align: center;
  font-family: var(--font-sans); font-size: 12.5px; line-height: 1.7;
  color: rgba(11, 11, 15, 0.55); word-break: keep-all;
}

/* ==================== EDGE MEDIA (풀블리드 이미지) ==================== */
.edge-media {
  max-width: 1280px;
  margin: 0 auto 44px;
  line-height: 0;
  overflow: hidden;
}
.edge-media img { display: block; width: 100%; height: auto; }
.edge-media.tall { margin-bottom: 0; }

/* ==================== INTRO ==================== */
.lp-intro { background: var(--pk-cream); padding: 100px 0; }
.intro-figure {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  margin: 10px 0 6px;
  line-height: 1;
}
.intro-num {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  font-size: 92px;
  line-height: 0.9;
  letter-spacing: -0.03em;
  color: var(--pk-gold-dark);
}
.intro-num-unit {
  font-family: var(--font-serif-kr);
  font-size: 24px;
  font-weight: 400;
  color: var(--pk-gold);
  letter-spacing: -0.02em;
}
.intro-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 2;
  color: var(--pk-grey);
  word-break: keep-all;
  max-width: 600px;
  margin: 0 auto;
}
.intro-lead strong { color: var(--pk-gold-dark); font-weight: 600; }

/* ==================== OVERVIEW ==================== */
.lp-overview { padding-top: 90px; }
.ov-list {
  margin: 8px 0 0;
  padding: 0;
  border-top: 2px solid var(--pk-gold);
}
.ov-row {
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 16px;
  padding: 16px 4px;
  border-bottom: 1px solid rgba(11, 11, 15, 0.07);
  align-items: start;
}
.ov-label {
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 700;
  color: var(--pk-gold-dark);
  line-height: 1.6;
}
.ov-value {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--pk-ink);
  line-height: 1.6;
  word-break: keep-all;
  margin: 0;
}
.ov-value strong { color: var(--pk-gold-dark); font-weight: 700; }

/* ==================== LOCATION ==================== */
.loc-map {
  margin: 0 0 12px;
  overflow: hidden;
  border: 1px solid var(--pk-gold-soft);
  background: #fff;
}
.loc-map img { display: block; width: 100%; height: auto; }

.loc-points {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 24px;
}
.loc-point {
  padding: 26px 20px 30px;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  transition: background 0.4s ease, border-color 0.4s ease;
}
.loc-point:hover { background: var(--pk-cream); border-color: var(--pk-gold); }
.loc-point-num {
  display: block;
  font-family: var(--font-serif-en);
  font-size: 26px; font-weight: 400; font-style: italic;
  color: var(--pk-gold);
  line-height: 1; margin-bottom: 14px;
}
.loc-point-en {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 9px; letter-spacing: 0.22em; font-weight: 600;
  color: rgba(11, 11, 15, 0.38);
  margin-bottom: 8px;
}
.loc-point-title {
  font-family: var(--font-serif-kr);
  font-size: 17px; font-weight: 500;
  color: var(--pk-noir);
  letter-spacing: -0.02em; line-height: 1.4;
  margin-bottom: 11px;
}
.loc-point-desc {
  font-family: var(--font-sans);
  font-size: 12.5px; font-weight: 400; line-height: 1.75;
  color: rgba(11, 11, 15, 0.58);
  word-break: keep-all;
}

.loc-closing {
  margin-top: 56px;
  padding: 52px 26px;
  text-align: center;
  border-top: 1px solid var(--pk-gold-soft);
  border-bottom: 1px solid var(--pk-gold-soft);
}
.loc-closing-en {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px; letter-spacing: 0.32em; font-weight: 600;
  color: var(--pk-gold-dark);
  margin-bottom: 20px;
}
.loc-closing-emph {
  font-family: var(--font-serif-kr);
  font-size: 20px; font-weight: 500; line-height: 1.6;
  color: var(--pk-noir);
}
.loc-closing-emph em { font-family: var(--font-serif-en); font-style: italic; color: var(--pk-gold-dark); }

/* ==================== SPLIT (이미지 + 텍스트) ==================== */
.lp-split { padding: 0; }
.split { display: flex; flex-direction: column; }
.split-media { margin: 0; line-height: 0; }
.split-media img { display: block; width: 100%; height: auto; }
.split-body { padding: 56px 26px 80px; text-align: center; }
.split-body .lp-gold-line { margin-left: auto; margin-right: auto; }
.split-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px; font-weight: 300; line-height: 1.95;
  color: var(--pk-grey);
  word-break: keep-all;
  max-width: 520px;
  margin: 0 auto;
}
.split-lead strong { color: var(--pk-gold-dark); font-weight: 600; }
.lp-park { background: var(--pk-cream); }

/* ==================== DISTRICT ==================== */
.lp-district { background: #fff; padding-top: 90px; }
.dist-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.dist-card {
  padding: 24px 18px 28px;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  transition: background 0.4s ease, border-color 0.4s ease;
}
.dist-card:hover { background: var(--pk-cream); border-color: var(--pk-gold); }
.dist-card.reveal { transform: translateY(32px) scale(0.95); }
.dist-card.reveal.is-revealed { transform: none; }
.dist-en {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 9px; letter-spacing: 0.18em; font-weight: 600;
  color: var(--pk-gold);
  margin-bottom: 8px;
}
.dist-ko {
  font-family: var(--font-serif-kr);
  font-size: 16px; font-weight: 600;
  color: var(--pk-noir);
  margin-bottom: 9px; letter-spacing: -0.02em;
  word-break: keep-all;
}
.dist-desc {
  font-family: var(--font-sans);
  font-size: 12px; line-height: 1.7;
  color: rgba(11, 11, 15, 0.56);
  word-break: keep-all;
}

/* ==================== SCALE ==================== */
.lp-scale { background: var(--pk-cream); padding-bottom: 0; }
.scale-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px; font-weight: 300; line-height: 1.9;
  color: var(--pk-grey);
  margin: 0 auto 44px; max-width: 640px;
  word-break: keep-all;
}

/* ==================== UNIT ==================== */
.lp-unit { background: #fff; }
.unit-tabs {
  display: flex; flex-wrap: nowrap; gap: 8px;
  margin: 6px 0 26px; padding: 4px 0;
  overflow-x: auto; scrollbar-width: none;
  justify-content: center;
}
.unit-tabs::-webkit-scrollbar { display: none; }
.unit-tab {
  flex-shrink: 0;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  padding: 11px 20px;
  cursor: pointer;
  font-family: var(--font-rounded);
  font-size: 13px; font-weight: 700; letter-spacing: 0.04em;
  color: var(--pk-ink);
  transition: all 0.25s ease;
}
.unit-tab:hover { border-color: var(--pk-gold); }
.unit-tab.active {
  background: var(--pk-gold);
  border-color: var(--pk-gold);
  color: #fff;
  box-shadow: 0 8px 20px -10px rgba(3, 35, 48, 0.6);
}
.unit-img-wrap {
  position: relative; width: 100%; min-height: 240px;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  overflow: hidden;
}
.unit-img { display: block; width: 100%; height: auto; transition: opacity 0.35s ease; }
.unit-img.is-loading { opacity: 0.3; }
.unit-loading {
  position: absolute; inset: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 14px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px); -webkit-backdrop-filter: blur(2px);
  pointer-events: none;
}
.unit-spinner {
  width: 30px; height: 30px; border-radius: 50%;
  border: 2px solid rgba(3, 35, 48, 0.2);
  border-top-color: var(--pk-gold);
  animation: unitSpin 0.8s linear infinite;
}
.unit-loading-label {
  font-family: var(--font-sans);
  font-size: 10px; letter-spacing: 0.42em; font-weight: 600;
  color: var(--pk-gold-dark);
}
@keyframes unitSpin { to { transform: rotate(360deg); } }
.unit-fade-enter-active, .unit-fade-leave-active { transition: opacity 0.3s ease; }
.unit-fade-enter-from, .unit-fade-leave-to { opacity: 0; }

.unit-spec {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
  margin: 22px 0 0;
  border-top: 1px solid var(--pk-gold-soft);
  border-left: 1px solid var(--pk-gold-soft);
}
.us-row {
  display: flex; flex-direction: column; gap: 6px;
  padding: 16px 14px;
  border-right: 1px solid var(--pk-gold-soft);
  border-bottom: 1px solid var(--pk-gold-soft);
}
.us-row dt {
  font-family: var(--font-sans);
  font-size: 11px; font-weight: 600; letter-spacing: 0.02em;
  color: rgba(11, 11, 15, 0.5);
}
.us-row dd {
  margin: 0;
  font-family: var(--font-rounded);
  font-size: 17px; font-weight: 700;
  color: var(--pk-noir);
}
.us-row dd strong { color: var(--pk-gold-dark); }

/* ==================== AMENITY ==================== */
.lp-amenity { background: var(--pk-cream); padding-top: 90px; }
.amenity-list {
  list-style: none; padding: 0; margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.amenity-list li {
  padding: 18px 18px;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  font-family: var(--font-serif-kr);
  font-size: 13.5px; font-weight: 500;
  color: var(--pk-ink);
  letter-spacing: -0.01em;
}

/* ==================== GALLERY ==================== */
.lp-gallery { background: #fff; }
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.gal { margin: 0; position: relative; overflow: hidden; line-height: 0; }
.gal img { display: block; width: 100%; height: 100%; object-fit: cover; aspect-ratio: 3 / 4; transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1); }
.gal:hover img { transform: scale(1.06); }
.gal figcaption {
  position: absolute; left: 0; right: 0; bottom: 0;
  padding: 16px 14px;
  background: linear-gradient(0deg, rgba(11,11,15,0.72), transparent);
  display: flex; flex-direction: column; gap: 3px;
  line-height: 1.3;
}
.gal-en { font-family: var(--font-mono-disp); font-size: 8px; letter-spacing: 0.2em; color: rgba(255,255,255,0.75); font-weight: 600; }
.gal-ko { font-family: var(--font-serif-kr); font-size: 14px; font-weight: 600; color: #fff; }

/* ==================== ROSEWOOD ==================== */
.lp-rosewood { background: var(--pk-noir); }
.lp-rosewood .lp-eyebrow { color: #7FA9B4; }
.lp-rosewood .lp-section-title { color: #fff; }
.lp-rosewood .lp-section-title em { color: #9AC7D1; }
.lp-rosewood .split-lead { color: rgba(255,255,255,0.7); }
.lp-rosewood .split-lead strong { color: #9AC7D1; }
.lp-rosewood .lp-gold-line { background: linear-gradient(90deg, #7FA9B4, transparent); }
.rose-perks {
  list-style: none; padding: 0; margin: 24px auto 0;
  max-width: 420px;
  text-align: left;
  display: flex; flex-direction: column; gap: 12px;
}
.rose-perks li {
  padding-left: 20px; position: relative;
  font-family: var(--font-sans);
  font-size: 14px; line-height: 1.6;
  color: rgba(255,255,255,0.82);
}
.rose-perks li::before {
  content: ''; position: absolute; left: 0; top: 9px;
  width: 6px; height: 6px; border-radius: 50%;
  background: #7FA9B4;
}
.rose-perks strong { color: #fff; font-weight: 700; }
.rose-note {
  margin-top: 22px;
  font-size: 11px; line-height: 1.7;
  color: rgba(255,255,255,0.42);
}

/* ==================== TRUST ==================== */
.lp-trust { background: #fff; }
.trust-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 14px;
  text-align: left;
}
.trust-card {
  padding: 26px 20px 30px;
  background: #fff;
  border: 1px solid var(--pk-gold-soft);
  transition: background 0.4s ease, border-color 0.4s ease;
}
.trust-card:hover { background: var(--pk-cream); border-color: var(--pk-gold); }
.trust-role {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 10px; letter-spacing: 0.18em; font-weight: 600;
  text-transform: uppercase;
  color: var(--pk-gold);
  margin-bottom: 10px;
}
.trust-name {
  font-family: var(--font-serif-kr);
  font-size: 16px; font-weight: 600;
  color: var(--pk-noir);
  margin-bottom: 9px; letter-spacing: -0.02em;
  line-height: 1.35;
}
.trust-desc {
  font-family: var(--font-sans);
  font-size: 12px; line-height: 1.7;
  color: var(--pk-grey);
  word-break: keep-all;
}

/* ==================== CTA ==================== */
.lp-cta {
  background: var(--pk-cream);
  padding: 100px 0 120px;
  position: relative; overflow: hidden;
}
.cta-desc {
  font-family: var(--font-serif-kr);
  font-size: 15px; font-weight: 400; line-height: 1.95;
  color: var(--pk-grey);
  margin-bottom: 36px;
}
.cta-desc strong { color: var(--pk-gold-dark); font-weight: 600; }
.cta-btn {
  background: var(--pk-gold);
  border: 1px solid var(--pk-gold);
  color: #fff;
  padding: 22px 30px;
  font-family: inherit;
  cursor: pointer;
  width: 100%; max-width: 360px; margin: 0 auto;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  position: relative; overflow: hidden;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.cta-btn::before {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--pk-gold-dark), var(--pk-gold));
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 0;
}
.cta-btn:hover::before { transform: translateY(0); }
.cta-btn > * { position: relative; z-index: 1; }
.cta-btn-en { font-family: var(--font-mono-disp); font-size: 11px; letter-spacing: 0.4em; color: #fff; font-weight: 500; }
.cta-btn-kr { font-family: var(--font-serif-kr); font-size: 17px; font-weight: 600; letter-spacing: 0.04em; }
.cta-btn-arrow { font-family: var(--font-serif-en); font-size: 18px; margin-top: 4px; color: #fff; transition: transform 0.4s; }
.cta-btn:hover .cta-btn-arrow { transform: translateX(4px); }
.cta-note {
  margin-top: 34px;
  font-family: var(--font-serif-kr);
  font-size: 11px; line-height: 1.8; font-weight: 400;
  color: rgba(11, 11, 15, 0.42);
}

/* ==================== RESPONSIVE (Tablet+) ==================== */
@media (min-width: 768px) {
  .lp-inner { padding: 0 40px; }
  .pc-br { display: inline; }
  .intro-num { font-size: 132px; }
  .intro-num-unit { font-size: 32px; }
  .lp-section { padding: 120px 0; }
  .lp-section-title { font-size: 42px; margin-bottom: 32px; }
  .lp-eyebrow { font-size: 12px; margin-bottom: 26px; }
  .lp-gold-line { width: 76px; margin-bottom: 48px; }

  .edge-media { margin-bottom: 60px; }
  .ov-row { grid-template-columns: 130px 1fr; padding: 18px 4px; }
  .ov-label, .ov-value { font-size: 15px; }

  .loc-points { margin-top: 40px; }
  .loc-point { padding: 44px 40px 48px; }
  .loc-point-num { font-size: 34px; margin-bottom: 18px; }
  .loc-point-en { font-size: 10px; margin-bottom: 10px; }
  .loc-point-title { font-size: 22px; margin-bottom: 15px; }
  .loc-point-desc { font-size: 14px; line-height: 1.85; }
  .loc-closing { margin-top: 72px; padding: 72px 40px; }
  .loc-closing-emph { font-size: 26px; }

  /* split → 2 columns */
  .split { flex-direction: row; align-items: stretch; min-height: 520px; }
  .split.reverse { flex-direction: row-reverse; }
  .split-media { flex: 1; }
  .split-media img { width: 100%; height: 100%; object-fit: cover; }
  .split-body {
    flex: 1; display: flex; flex-direction: column; justify-content: center;
    padding: 80px 6vw;
  }
  .split-lead { font-size: 16px; }

  .dist-grid { grid-template-columns: repeat(3, 1fr); }
  .dist-ko { font-size: 17px; }

  .unit-spec { grid-template-columns: repeat(4, 1fr); }
  .amenity-list { grid-template-columns: repeat(3, 1fr); gap: 12px; }
  .amenity-list li { padding: 20px 22px; font-size: 15px; }
  .gallery-grid { grid-template-columns: repeat(4, 1fr); gap: 14px; }
  .trust-card { padding: 44px 36px 48px; }
  .trust-name { font-size: 19px; }
  .trust-desc { font-size: 13px; }
}

@media (min-width: 1024px) {
  .lp-section-title { font-size: 50px; }
  .dist-desc { font-size: 12.5px; }
}
</style>
